import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {}

  isAuthenticated(): boolean {
    return !!this.token;
  }

  get credentials(): string | null {
    return this.token;
  }

  get token(): string | null {
    return sessionStorage.getItem('authorization');
  }
}
